import * as Rest from 'src/constants/rest'
import http from 'src/utils/Http'

export function createRequest(
  lexonExpedientId: string,
  lexonExpedientIdOwnFile: string,
  lexonExpedientNig: string | null,
  lexonExpedientDescription: string | null,
  mensajeId: string,
  lexonCompanyId: string,
  lexonCompanyName: string,
  classificationName: string | null,
  expireDate: string | null
): Promise<any> {
  return http.post({
    url: Rest.MENSAJE_LEXON_CLASSIFICATIONS,
    token: true,
    params: {
      lexonExpedientId,
      lexonExpedientIdOwnFile,
      lexonExpedientNig,
      lexonExpedientDescription,
      mensajeId,
      lexonCompanyId,
      lexonCompanyName,
      classificationName,
      expireDate
    }
  })
}

export function deleteRequest(id: number): Promise<any> {
  return http.delete({
    url: Rest.MENSAJE_LEXON_CLASSIFICATION(id),
    token: true,
    params: {}
  })
}
